import { ResponsiveBullet } from '@nivo/bullet';

const performanceData = [
  { id: 'Region A', ranges: [100, 200, 300], measures: [220], markers: [250] },
  { id: 'Region B', ranges: [100, 200, 300], measures: [270], markers: [260] },
  { id: 'Region C', ranges: [100, 200, 300], measures: [180], markers: [240] },
  { id: 'Region D', ranges: [100, 200, 300], measures: [290], markers: [280] },
];

export const SalesPerformanceChart = () => (
    <div style={{ height: '300px' }}>
        <ResponsiveBullet
            data={performanceData}
            margin={{ top: 50, right: 90, bottom: 50, left: 90 }}
            markerColors="black"
            measureColors="black"
            measureSize={0.2}
            rangeColors="nivo"
            spacing={46}
            titleAlign="start"
            titleOffsetX={-70}
        />
    </div>
);